<template>
  <div class="page-404-error">
    <div class="error-logo">
      <div class="number">4</div>
      <img
        src="@/assets/images/element/lemon.svg"
        alt="Yuzu lemon"
        class="lemon"
      />
      <div class="number">4</div>
    </div>
    <div class="block-content">
      <div class="error-small">ERREUR 404</div>
      <h1>Oups ! La page que vous cherchez semble introuvable...</h1>
      <p>
        N’hésitez pas à retourner sur la page d’accueil pour trouver votre
        chemin.
      </p>
    </div>
    <Button
      class="primary"
      label="Retourner à la page d'accueil"
      @click="$router.push('/')"
    />
  </div>
</template>
